/*
    Module definition for browserify
*/
require('./dist/filepicker');
module.exports = filepicker;



//////////////////
// WEBPACK FOOTER
// ./node_modules/filepicker-js/index.js
// module id = 2173
// module chunks = 0